import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UserManagementService } from '../user-management/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChatpopupComponent } from 'src/app/components/chatpopup/chatpopup.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public selectedSite = '';
  public sitesList: any[] = [];
  constructor(private userService: UserManagementService,private modalserivce: NgbModal) { }

  ngOnInit(): void {
    this.onSiteAdded();
  }
  ngAfterViewInit() {
    this.getSiteList();
  }

  getSiteList() {
    const siteList = this.userService.getSiteDetail();
    if (siteList && siteList.length) {
      this.sitesList = siteList;
      const userDetail = this.userService.getUserDetail();
      if (userDetail && userDetail.role == 1 && this.sitesList && this.sitesList.length) {
        setTimeout(() => {
          this.selectedSite = this.sitesList[0].site_id;
          this.onSiteChange(this.selectedSite);
        })
      }
    }
  }

  onSiteChange(event) {
    this.userService.updateMessage({ 'purpose': 'sitechanged', 'value': event });
    this.userService.selectedSite = this.selectedSite;
  }

  onSiteAdded() {
    this.userService.getMessage().subscribe(data => {
      if (data.purpose === 'siteadded') {
        this.sitesList = data.value;
        if (this.sitesList && this.sitesList.length) {
          const allSiteIds = this.sitesList.map(ele => ele.site_id);
          if (!allSiteIds.includes(this.selectedSite)) {
            this.selectedSite = '';
            setTimeout(() => {
              this.selectedSite = allSiteIds[0];
              this.userService.selectedSite = String(this.selectedSite);
            });
          } else {
            this.selectedSite = '';
            setTimeout(() => this.selectedSite = String(this.userService.selectedSite));
          }
        }
      }
    });
  }
  onChange() {
    this.selectedSite = null;
    this.selectedSite = this.userService.selectedSite;
  }
  aiPopShow(data) {
    const modalRef = this.modalserivce.open(ChatpopupComponent,{ size : 'l', backdrop: 'static' });
    modalRef.componentInstance.src = data;
    modalRef.componentInstance.event = event;
    setTimeout(() => {
      const modalElement = document.querySelector('.modal');
      if (modalElement) {
        (modalElement as HTMLElement).style.zIndex = '1100';
      }
    }, 0);
  }
  logout() {
    console.log('🚪 Logout method called');
    
    // Clear filter selections before logout
    this.clearAllFilterSelections();
    
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
    
    console.log('✅ Logout completed');
  }

  // Test method - you can call this from browser console to test localStorage clearing
  public testClearFilters(): void {
    console.log('🧪 Testing filter cleanup...');
    this.clearAllFilterSelections();
  }

  // Test method - creates test filter data to verify clearing works
  public createTestFilterData(): void {
    console.log('🧪 Creating test filter data...');
    localStorage.setItem('reportFilter_2_51', '1');
    localStorage.setItem('reportFilter_12_30', '5');
    localStorage.setItem('reportFilter_6_25', '3');
    localStorage.setItem('test_other_data', 'some_value');
    console.log('✅ Test filter data created. Now try testClearFilters()');
  }

  // Simple method to check current localStorage state
  public checkLocalStorage(): void {
    console.log('📊 Current localStorage state:');
    console.log('Total items:', localStorage.length);
    console.log('All keys:', Object.keys(localStorage));
    console.log('Filter keys:', Object.keys(localStorage).filter(key => key.startsWith('reportFilter_')));
  }

  // Force clear all filter data (nuclear option)
  public forceClearFilters(): void {
    console.log('💥 Force clearing all filter data...');
    const allKeys = Object.keys(localStorage);
    const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
    
    filterKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log(`💥 Force removed: ${key}`);
    });
    
    console.log(`💥 Force cleared ${filterKeys.length} filter keys`);
    this.checkLocalStorage();
  }

  private clearAllFilterSelections(): void {
    try {
      console.log('🔍 Starting filter cleanup...');
      console.log('📊 Total localStorage items:', localStorage.length);
      
      // Method 1: Using Object.keys (more reliable)
      const allKeys = Object.keys(localStorage);
      console.log('📋 All localStorage keys (Object.keys):', allKeys);
      
      const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
      console.log('🎯 Filter keys found:', filterKeys);
      
      // Method 2: Using traditional loop
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('reportFilter_')) {
          keysToRemove.push(key);
        }
      }
      console.log('🎯 Filter keys found (loop method):', keysToRemove);
      
      // Clear using both methods for redundancy
      const allFilterKeys = [...new Set([...filterKeys, ...keysToRemove])];
      console.log('🗑️ All unique filter keys to remove:', allFilterKeys);
      
      allFilterKeys.forEach(key => {
        const value = localStorage.getItem(key);
        console.log(`Removing key: ${key} with value: ${value}`);
        localStorage.removeItem(key);
        console.log(`✅ Cleared filter selection for key: ${key}`);
      });
      
      console.log(`🎉 Manual logout cleanup: Cleared ${allFilterKeys.length} filter selections`);
      
      // Verify removal
      const remainingKeys = Object.keys(localStorage).filter(key => key.startsWith('reportFilter_'));
      console.log('🔍 Remaining filter keys after cleanup:', remainingKeys);
      
      if (remainingKeys.length > 0) {
        console.warn('⚠️ Some filter keys still remain! Trying alternative method...');
        // Alternative method - clear all localStorage and restore non-filter items
        this.clearAllAndRestore();
      }
      
    } catch (e) {
      console.error('❌ Error clearing filter selections during manual logout:', e);
    }
  }

  private clearAllAndRestore(): void {
    try {
      console.log('🔄 Using alternative clearing method...');
      
      // Get all non-filter keys
      const allKeys = Object.keys(localStorage);
      const nonFilterKeys = allKeys.filter(key => !key.startsWith('reportFilter_'));
      const nonFilterData: { [key: string]: string } = {};
      
      // Store non-filter data
      nonFilterKeys.forEach(key => {
        nonFilterData[key] = localStorage.getItem(key) || '';
      });
      
      console.log('💾 Stored non-filter data:', Object.keys(nonFilterData));
      
      // Clear all localStorage
      localStorage.clear();
      console.log('🧹 Cleared all localStorage');
      
      // Restore non-filter data
      Object.entries(nonFilterData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      
      console.log('🔄 Restored non-filter data');
      console.log('✅ Alternative clearing method completed');
      
    } catch (e) {
      console.error('❌ Error in alternative clearing method:', e);
    }
  }

}
